import React from "react";
import { Sun, Mail } from "lucide-react";

// Näkyy 2.8.2026 asti, piiloutuu automaattisesti 3.8.2026 alkaen
const isBreakNoticeActive = () => new Date() < new Date(2026, 7, 3);

export const SummerBreakBanner = () => {
  if (!isBreakNoticeActive()) return null;
  return (
    <div data-testid="summer-break-banner" className="bg-amber-400 text-stone-900">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center text-sm md:text-base">
        <Sun className="w-4 h-4 shrink-0" />
        <span className="font-semibold">Lounastauko 6.7.–2.8.</span>
        <span className="hidden sm:inline">—</span>
        <span>
          Catering-tilauksia otetaan normaalisti vastaan:{" "}
          <a href="mailto:catering@vanikka.net" data-testid="banner-email-catering" className="font-semibold underline underline-offset-2 hover:text-stone-700">catering@vanikka.net</a>
          {" "}ja{" "}
          <a href="mailto:info@datalounas.com" data-testid="banner-email-info" className="font-semibold underline underline-offset-2 hover:text-stone-700">info@datalounas.com</a>
        </span>
        <span className="font-semibold">Lounas jatkuu normaalisti ma 3.8.</span>
      </div>
    </div>
  );
};

export const SummerBreakCard = () => {
  if (!isBreakNoticeActive()) return null;
  return (
    <section data-testid="summer-break-card" className="max-w-5xl mx-auto px-6 pt-12">
      <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-300 rounded-3xl p-6 md:p-8 text-center shadow-sm">
        <div className="inline-flex items-center justify-center w-14 h-14 bg-amber-400 rounded-full mb-4">
          <Sun className="w-7 h-7 text-white" />
        </div>
        <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-2">
          Lounastauko 6.7.–2.8.
        </h2>
        <p className="text-stone-600 mb-2 max-w-xl mx-auto">
          Lounas on kesätauolla, mutta catering-tilauksia otetaan normaalisti vastaan!
        </p>
        <p className="text-stone-800 font-semibold mb-5">
          Lounas jatkuu normaalisti ma 3.8.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="mailto:catering@vanikka.net"
            data-testid="break-card-email-catering"
            className="inline-flex items-center gap-2 bg-white border border-amber-300 text-stone-800 px-5 py-2.5 rounded-full font-medium hover:bg-amber-100 transition-colors"
          >
            <Mail className="w-4 h-4 text-amber-600" />
            catering@vanikka.net
          </a>
          <a
            href="mailto:info@datalounas.com"
            data-testid="break-card-email-info"
            className="inline-flex items-center gap-2 bg-white border border-amber-300 text-stone-800 px-5 py-2.5 rounded-full font-medium hover:bg-amber-100 transition-colors"
          >
            <Mail className="w-4 h-4 text-amber-600" />
            info@datalounas.com
          </a>
        </div>
      </div>
    </section>
  );
};
